define('CSS3Events',['modernizr'],function(){
   
   var transEndEventNames = {
       'WebkitTransition' : 'webkitTransitionEnd', // Saf 6, Android Browser
       'MozTransition'    : 'transitionend',       // only for FF < 15
       'transition'       : 'transitionend'        // IE10, Opera, Chrome, FF 15+, Saf 7+
   };
   
   return function(event){
      switch(event){
         case 'transitionend' :
            return transEndEventNames[Modernizr.prefixed('transition')];
         default : 
            return event;
      }
   }
});
